var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCommandSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 15.15c-.41 0-.75-.34-.75-.75V9.6c0-.41.34-.75.75-.75h4.8c.41 0 .75.34.75.75v4.8c0 .41-.34.75-.75.75H9.6zm4.05-1.5v-3.3h-3.3v3.3h3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.2c0-1.41 1.14-2.55 2.55-2.55h1.8c.41 0 .75.34.75.75v1.8c0 1.41-1.14 2.55-2.55 2.55s-2.55-1.14-2.55-2.55zm1.5 0a1.05 1.05 0 1 0 2.1 0v-1.05H7.8c-.58 0-1.05.47-1.05 1.05zM7.8 10.35c-1.41 0-2.55-1.14-2.55-2.55S6.39 5.25 7.8 5.25s2.55 1.14 2.55 2.55v1.8c0 .41-.34.75-.75.75H7.8zM6.75 7.8c0 .58.47 1.05 1.05 1.05h1.05V7.8a1.05 1.05 0 1 0-2.1 0zM14.4 10.35c-.41 0-.75-.34-.75-.75V7.8c0-1.41 1.14-2.55 2.55-2.55s2.55 1.14 2.55 2.55-1.14 2.55-2.55 2.55h-1.8zm1.8-1.5a1.05 1.05 0 1 0-1.05-1.05v1.05h1.05zM13.65 16.2v-1.8c0-.41.34-.75.75-.75h1.8c1.41 0 2.55 1.14 2.55 2.55s-1.14 2.55-2.55 2.55-2.55-1.14-2.55-2.55zm1.5 0a1.05 1.05 0 1 0 1.05-1.05h-1.05v1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCommandSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-command-square.a0be5b7744d59003d3a63a06e29f23ce.svg";
export { ForwardRef as ReactComponent };